
import ApiService from './ApiService'

class OrganisationTagService {
  set = async (apiToken, params, data) => {

    if (!params.orgId) {
      throw new Error('Missing organisation ID')
    }

    var url = '/admin/organisationtag'

    var options = {
      data: data
    }

    try {
      var result = await ApiService.put(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  get = async (apiToken, params, where) => {

    if (!params.orgId) {
      throw new Error('Missing organisation ID')
    }

    var url = '/admin/organisationtag'

    if (where) {
      params.where = where
    }

    params.limit = 1000

    try {
      var organisationTags = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return organisationTags?.data
  }
}
export default new OrganisationTagService()
